import { useStyles } from '@webapps/styles';
import { Tab } from '@material-ui/core';
import { useAuth, useMutation, useQuery } from '@webapps/reactjs-tech-components';
import { useEffect, useState } from 'react';
import { getRelationsBySchool } from '@webapps/business';
import CFAKeyContainer from './components/CFAKeyContainer';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import Trainings from './components/Trainings';
import Relations from './components/Relations';

const SchoolConnections = () => {
  const { classes, css, global, theme: { fontSizes, spacing } } = useStyles();

  const { checkPermissions, isPremium, idUser } = useAuth();

  const [tabValue, setTabValue] = useState('1');

  const { data: { content: relations = [] } = {}, refetch, isLoading } = useQuery(getRelationsBySchool, {
    key: ['relations', idUser],
    variables: { id: idUser },
  });

  useEffect(() => {
    if (isPremium !== null) {
      checkPermissions();
    }
  }, [isPremium]);


  if (!isPremium) {
    return (<div></div>);
  }

  return (
    <div className={global.container}>
      <CFAKeyContainer refetch={refetch} />
      <TabContext value={tabValue}>
        <TabList className={classes.tabContainer} indicatorColor="default" onChange={(e, v) => setTabValue(v)} >
          <Tab className={[global.mainTitle, global.tab, css({ height: 40 }), tabValue === '1' && global.activeTab]} label="Centres de formation" value="1" />
          <Tab className={[global.mainTitle, global.tab, css({ height: 40 }), tabValue === '2' && global.activeTab]} label="Formations" value="2" />
        </TabList>
        <TabPanel className={global.tabPanel} value="1" >
          <Relations relations={relations} isLoading={isLoading} />
        </TabPanel>
        <TabPanel className={global.tabPanel} value="2" >
          <Trainings relations={relations} isLoading={isLoading} />
        </TabPanel>
      </TabContext>
    </div>
  );
};

export default SchoolConnections;
